import { ArrayHelper, DynamicTableHelper } from "@workspace/common";

const CANDIDATE_INITIAL_OPTIONS = [
  {
    label: "Candidate Last Name",
    value: "candidateSubmissionData.lastName",
    sort: true,
    sortValue: "candidate_submission_data.lastName",
  },
  {
    label: "Candidate Owner",
    value: "candidateSubmissionData.candidateOwner",
    sort: true,
    sortValue: "candidate_submission_data.candidateOwner",
  },
  {
    label: "Candidate Nationality",
    value: "candidateSubmissionData.candidateNationality",
    sort: true,
    sortValue: "candidate_submission_data.candidateNationality",
  },
  {
    label: "Candidate Status",
    value: "candidateSubmissionData.candidateStatus",
    sort: true,
    sortValue: "candidate_submission_data.candidateStatus",
  },
  {
    label: "Visa Status",
    value: "candidateSubmissionData.visaStatus",
    sort: true,
    sortValue: "candidate_submission_data.visaStatus",
  },
  {
    label: "Created By",
    value: "createdByName",
    sort: true,
    sortValue: "createdByName",
  },
  {
    label: "Created On",
    value: "createdAt",
    sort: true,
    sortValue: "created_at",
  },
  {
    label: "Email",
    value: "candidateSubmissionData.email",
    sort: true,
    sortValue: "candidate_submission_data.email",
  },
];

const CANDIDATE_MANDATORY_OPTIONS = [
  {
    sortValue: "candidate_submission_data.candidateId",
    label: "Pulse Candidate Id",
    value: "candidateSubmissionData.candidateId",
    sort: true,
    expand: true,
  },
  {
    label: "Candidate First Name",
    value: "candidateSubmissionData.firstName",
    sort: true,
    sortValue: "candidate_submission_data.firstName",
    expand: true,
  },
];

const CANDIDATE_MAIN_FIELDS = [
  {
    label: "Created By",
    value: "createdByName",
    sort: true,
    sortValue: "createdByName",
  },
  {
    label: "Updated By",
    value: "updatedByName",
    sort: true,
    sortValue: "updatedByName",
  },
  {
    label: "Created At",
    value: "createdAt",
    sort: true,
    sortValue: "created_at",
  },
  {
    label: "Updated At",
    value: "updatedAt",
    sort: true,
    sortValue: "updated_at",
  },
];

const generateCandidateFields = (candidateForm) => {
  const fields = [...CANDIDATE_MAIN_FIELDS];

  if (candidateForm) {
    const candidateOptions = DynamicTableHelper.buildOptionsArray(
      candidateForm?.formSchema,
      "candidateSubmissionData",
      "candidate_submission_data",
      "Candidate"
    );
    fields.push(...candidateOptions);
  }

  // Remove duplicate value in the object of array. Keep the first
  const fieldsNew = fields.filter(
    (field, index, self) =>
      index === self.findIndex((t) => t.value === field.value)
  );

  ArrayHelper.sortArrayObjIcase(fieldsNew, "label");

  return fieldsNew;
};

export { CANDIDATE_INITIAL_OPTIONS, CANDIDATE_MANDATORY_OPTIONS, generateCandidateFields};
